module.exports = __webpack_public_path__ + "static/media/screenshot.37d61d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Device/devices/WaveBlockShowcase/screenshot.png
// module id = 230
// module chunks = 0